(function () {
	'use strict';

	/**
	 * Conmutador de paneles de la sección de familia.
	 *
	 * Los dos paneles están SIEMPRE en el DOM; pulsar una pestaña solo mueve el
	 * atributo data-open de uno a otro, y la transición la hace el CSS. Así el
	 * contenido del panel cerrado sigue siendo indexable y accesible, y no hace
	 * falta ni una petición ni recalcular alturas.
	 */
	function initSwitch(root) {
		var paneles = root.querySelectorAll('[data-reyes-panel]');
		if (paneles.length < 2) {
			return; // con un solo panel no hay nada que conmutar
		}

		// En movil no hay conmutador: los dos paneles salen enteros y la
		// pestaña es solo un rotulo. El CSS ya los enseña; esto es para que lo
		// que anuncia el lector de pantalla coincida con lo que se ve.
		var escritorio = window.matchMedia('(min-width: 992px)');

		function sincronizar() {
			if (escritorio.matches) {
				paneles.forEach(function (p) {
					var t = p.querySelector('.reyes-switch__tab');
					if (t) {
						t.setAttribute('aria-expanded', p.hasAttribute('data-open') ? 'true' : 'false');
					}
				});
				return;
			}

			paneles.forEach(function (p) {
				var t = p.querySelector('.reyes-switch__tab');
				if (t) {
					t.setAttribute('aria-expanded', 'true');
				}
			});
		}

		sincronizar();
		escritorio.addEventListener('change', sincronizar);

		root.addEventListener('click', function (e) {
			if (!escritorio.matches) {
				return; // apilados, pulsar la pestaña no tiene que hacer nada
			}

			var tab = e.target.closest('.reyes-switch__tab');
			if (!tab || !root.contains(tab)) {
				return;
			}

			var panel = tab.closest('[data-reyes-panel]');
			if (!panel || panel.hasAttribute('data-open')) {
				return; // pulsar la pestaña ya abierta no cierra: siempre hay uno abierto
			}

			paneles.forEach(function (p) {
				var abierto = (p === panel);
				p.toggleAttribute('data-open', abierto);
				var t = p.querySelector('.reyes-switch__tab');
				if (t) {
					t.setAttribute('aria-expanded', abierto ? 'true' : 'false');
				}
			});
		});
	}

	/**
	 * Pestañas del selector de fechas. Mismo patrón que el conmutador: los
	 * paneles estan todos en el DOM y solo se alterna cual esta visible.
	 */
	function initTabs(root) {
		var botones = root.querySelectorAll('.reyes-tabs__btn');
		if (botones.length < 2) {
			return; // con una sola pestaña no hay nada que conmutar
		}

		root.addEventListener('click', function (e) {
			var btn = e.target.closest('.reyes-tabs__btn');
			if (!btn || !root.contains(btn) || btn.hasAttribute('data-active')) {
				return;
			}

			botones.forEach(function (b) {
				var activa = (b === btn);
				b.toggleAttribute('data-active', activa);
				b.setAttribute('aria-selected', activa ? 'true' : 'false');

				var panel = document.getElementById(b.getAttribute('aria-controls'));
				if (panel) {
					panel.hidden = !activa;
				}
			});
		});

		// Flechas izquierda y derecha entre pestañas, que es lo que espera
		// quien navega con teclado en un tablist.
		root.addEventListener('keydown', function (e) {
			if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
				return;
			}
			var lista = Array.prototype.slice.call(botones);
			var i = lista.indexOf(document.activeElement);
			if (i === -1) {
				return;
			}
			e.preventDefault();
			var siguiente = e.key === 'ArrowRight' ? (i + 1) % lista.length : (i - 1 + lista.length) % lista.length;
			lista[siguiente].focus();
			lista[siguiente].click();
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		/**
	 * Red de seguridad para los bloques que recortan y tienen un ancla dentro.
	 *
	 * El CSS los pone en `overflow: clip`, que no crea contenedor desplazable.
	 * Un navegador que no conozca `clip` se queda en el `hidden` de respaldo, y
	 * ahi el salto a un ancla desplaza el BLOQUE en vez de la pagina: el hero
	 * desaparece por arriba y no vuelve, porque un `hidden` no pinta barra.
	 * Esto lo devuelve a su sitio.
	 */
	function anclarRecortados() {
		document.querySelectorAll('.reyes-top, .reyes-arena').forEach(function (bloque) {
			bloque.addEventListener('scroll', function () {
				bloque.scrollTop = 0;
				bloque.scrollLeft = 0;
			});
		});
	}

	anclarRecortados();
	document.querySelectorAll('[data-reyes-switch]').forEach(initSwitch);
		document.querySelectorAll('[data-reyes-tabs]').forEach(initTabs);
	});
})();
